import { Question, QuestionTypes } from '@playbooks/core/src/interfaces/ActionCard'

export default function isDropdownQuestion(value: Question): value is Question<number> {
  return value.type === QuestionTypes.DROPDOWN
}
